import { connect } from 'react-redux';
import { getVerificationEmailAddress, getVerificationLoadingState } from '../publicSession/selectors';
import { openUserDropdown } from '../SiteHeader/redux/actions';
import { resendVerificationEmail } from '../publicSession/actions';
import { dropFirstTimeFlag } from '../redux/firstTimeFlags/actions';
const mapStateToProps = (state)=>{
    var _getVerificationLoadingState;
    return {
        email: getVerificationEmailAddress(state),
        isSendingDone: (_getVerificationLoadingState = getVerificationLoadingState(state)) === null || _getVerificationLoadingState === void 0 ? void 0 : _getVerificationLoadingState.isSendingDone
    };
};
const mapDispatchToProps = {
    changeEmail: openUserDropdown,
    resendEmail: resendVerificationEmail,
    dropFirstTimeFlag
};
export default connect(mapStateToProps, mapDispatchToProps);
